export default __webpack_public_path__ + "static/media/Nainital05.498a0cff.png";